import { Menu, MenuItem, Typography } from "@mui/material";
import { href } from "react-router-dom";

interface props {
    menuAnchorEl: any,
    handleMenuClose: () => void
}

const MenuList: React.FC<props> = ({ menuAnchorEl, handleMenuClose }) => {
    const items = [
        { label: "About Us", href: "/about-us.html" },
        { label: "Updates" },
        { label: "Blog" },
        { label: "Career", href: "/career.html" },
        { label: "News" },
        { label: "Help", href: "/help-center.html" },
        { label: "Contact Us", href: "/contact-us.html" },
        { label: "Talk To Dedicated Expert", href: "/online-legal-consultation.html" },
    ];
    return (
        <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={handleMenuClose}

            PaperProps={{
                sx: {
                    bgcolor: "#a24857",
                    color: "#fff",
                    mt: 1,
                    borderRadius: "0.625rem",
                    minWidth: "12.5rem", // 200px converted to rem
                },
            }}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
        >
            {items?.map((item) => (
                <MenuItem
                    key={item.label}
                    onClick={() => {
                        handleMenuClose();
                        if (item.href) {
                            window.location.href = item.href;
                        } // ⬅️ Redirect logic
                    }}
                    sx={{
                        justifyContent: "center",
                        "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
                    }}
                >
                    <Typography
                        color="background.default"
                        sx={{ fontSize: "14px" }}
                    >
                        {item.label}
                    </Typography>
                </MenuItem>
            ))}
        </Menu>
    );
};

export default MenuList;
